import React, { Fragment } from 'react';
import {
  Checkbox as DefaultCheckbox,
  FormControlLabel as DefaultFormControlLabel
} from '@ui-propulsion/react-components';
import PopoutWindow from 'react-new-window';
import { any, arrayOf, bool, string, func, shape, node } from 'prop-types';

export const Checkbox = ({
  value,
  label,
  showErrors,
  validationErrors,
  ...props
}) => {
  const errors = showErrors
    ? validationErrors && validationErrors[props.name]
    : null;
  const controlElement = (
    <DefaultCheckbox {...props} value={value} error={Boolean(errors)} />
  );
  const checkboxElement = label ? (
    <DefaultFormControlLabel
      control={controlElement}
      value={value}
      error={Boolean(errors)}
      label={
        <>
          {label}
          {errors}
        </>
      }
    />
  ) : (
    controlElement
  );

  return checkboxElement;
};

Checkbox.propTypes = {
  value: string,
  label: node,
  name: string,
  showError: bool,
  validationErrors: shape({})
};

const mapAgreements = (agreements = [], openAgreement) => {
  const nonZeroBasedLength = agreements.length - 1;
  return agreements.map((agreement, id) => {
    return (
      <Fragment key={id}>
        {nonZeroBasedLength === id && nonZeroBasedLength ? 'and ' : null}
        <span
          className="link-investor-bold"
          onClick={e => {
            e.preventDefault();
            openAgreement(e);
          }}
          data-agreements-link={agreement.link}
        >
          {nonZeroBasedLength !== id ? `${agreement.name}, ` : agreement.name}
        </span>
      </Fragment>
    );
  });
};

export const CheckboxAgreements = ({
  agreements,
  showLinkFront,
  openAgreement,
  isPoppedOut,
  onClosingPopout,
  popoutURL,
  label,
  ...props
}) => {
  const agreementsList = mapAgreements(agreements, openAgreement);
  const popOutWindow = isPoppedOut ? (
    <PopoutWindow url={popoutURL} title="_blank" onUnload={onClosingPopout} />
  ) : null;
  const labelWithAgreements = showLinkFront ? (
    <>
      {agreementsList}
      {label}
    </>
  ) : (
    <>
      {label}
      {agreementsList}
    </>
  );

  return (
    <>
      {popOutWindow}
      <Checkbox {...props} label={labelWithAgreements} />
    </>
  );
};

CheckboxAgreements.propTypes = {
  agreements: arrayOf(any).isRequired,
  showLinkFront: bool,
  openAgreement: func,
  isPoppedOut: bool,
  onClosingPopout: func,
  popoutURL: string,
  value: string,
  label: node,
  name: string,
  showError: bool,
  validationErrors: shape({})
};

require('/var/lib/jenkins/workspace/auto-borrower-apply-ui_Release_0/src/shared_modules/propulsion/components/Checkbox/Checkbox.scss');